import { t } from '../../i18n.es.js';
import React from 'react';
import { styled } from '@teko/ui';
import background from './assets/flash-sale-background.es.js';
import { FlashSaleFilled } from '@teko/ds-icon';
import { FlashSaleBadgeTime } from '../FlashSaleBadgeTime/FlashSaleBadgeTime.es.js';

const Wrapper = styled.div((props) => {
  const styles = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: `${props.backgroundColor || "red"}`,
    backgroundImage: `url("${background}"), ${!props.backgroundColor && (props.backgroundLinearGradient || "linear-gradient(275deg, #ff8949, #eb2101)")}`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    textTransform: "uppercase",
    whiteSpace: "nowrap",
    overflow: "hidden",
    borderRadius: "2.5rem!important"
  };
  if (props.size == "lg") {
    styles.height = "2.5rem";
    styles.lineHeight = "2.5rem";
    styles.padding = "8px";
    styles.paddingRight = "12px";
    styles.fontSize = "13px";
  } else {
    styles.height = "1.2rem";
    styles.lineHeight = "1rem";
    styles.padding = "4px";
    styles.paddingRight = "8px";
    styles.fontSize = "10px";
  }
  return styles;
});
const ProductSold = styled.div(({ size }) => `
  color: #fff;
  margin-left: ${size === "sm" ? "4" : "8"}px;
  font-size: ${size === "sm" ? "8" : "10"}px;
  display: flex;
  align-items: center;
`);
const ProductSoldWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-right: 0.5rem;
`;
const FlashSaleBadge = ({
  sold,
  total,
  endAt,
  backgroundLinearGradient,
  backgroundColor,
  size = "sm",
  className,
  stock
}) => {
  const remain = Math.min(total - sold, stock || Number.MAX_SAFE_INTEGER);
  const message = sold / total > 0.9 || remain < 5 ? t("S\u1EAFp ch\xE1y h\xE0ng") : t("C\xF2n l\u1EA1i {{remain}}", { remain });
  const hidden = remain <= 0;
  if (hidden) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(Wrapper, {
    className,
    backgroundLinearGradient,
    backgroundColor,
    size
  }, /* @__PURE__ */ React.createElement(ProductSoldWrapper, null, /* @__PURE__ */ React.createElement(FlashSaleFilled, {
    color: "#FFD591",
    size: size == "lg" ? 24 : 16
  }), /* @__PURE__ */ React.createElement(ProductSold, {
    size
  }, message)), endAt && /* @__PURE__ */ React.createElement(FlashSaleBadgeTime, {
    size,
    endAt
  }));
};

export { FlashSaleBadge };
